import { render, staticRenderFns } from "./CpfField.vue?vue&type=template&id=29f8fbf9&scoped=true&"
import script from "./CpfField.vue?vue&type=script&lang=js&"
export * from "./CpfField.vue?vue&type=script&lang=js&"
import style0 from "./CpfField.vue?vue&type=style&index=0&id=29f8fbf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f8fbf9",
  null
  
)

export default component.exports